import { Link as RouterLink } from 'react-router-dom';
import { Card, CardContent, Typography } from '@mui/material';

import type { Spread } from '@/data/spreads';

import {
  spreadCardCaptionSx,
  spreadCardContentSx,
  spreadCardDescriptionSx,
  spreadCardRootSx,
  spreadCardTitleSx,
} from './SpreadCard.styles';

interface Props {
  spread: Spread;
}

function SpreadCard({ spread }: Props) {
  return (
    <Card
      component={RouterLink}
      to={`/reading?spread=${spread.key}`}
      aria-label={`Start a ${spread.name} reading`}
      sx={spreadCardRootSx}
    >
      <CardContent sx={spreadCardContentSx}>
        <Typography variant="h6" component="h3" color="primary" sx={spreadCardTitleSx}>
          {spread.name}
        </Typography>
        <Typography variant="body2" sx={spreadCardDescriptionSx}>
          {spread.description}
        </Typography>
        <Typography variant="caption" color="secondary" sx={spreadCardCaptionSx}>
          {spread.size} {spread.size === 1 ? 'card' : 'cards'}
        </Typography>
      </CardContent>
    </Card>
  );
}

export default SpreadCard;
